export class ProcedureTrainingCredited{
  public creditDate?: Date;
}
